export default {
  "privacy-policy": "https://www.vodacom.co.za/vodacom/terms/privacy-policy",
  "terms-and-conditions": "https://www.vodacom.co.za/vodacom/terms/terms-and-conditions",
  "help-and-support": "https://ayudacliente.vodafone.es/particulares/temas-de-ayuda/",
  "cookie-preferences": "cookie-preferences",
};
